import { useState } from 'react'
import { useAuth } from '../auth/AuthContext'
import { Button } from './ui/Button'
import { VerifyCodeForm } from './VerifyCodeForm'

// VerifyEmailBanner shows for a signed-in user whose email is not yet verified
// (the email/password signup path — social sign-ins return emailVerified=true).
// The server gates glow-create on email_verified (CA3), so an unverified owner
// would otherwise hit a confusing 403 with no path forward. "Enter code"
// inline-expands the shared VerifyCodeForm (which auto-sends a fresh code and
// owns its own resend); the banner self-dismisses the moment emailVerified
// flips true (confirmVerifyCode's forced refresh re-renders this).
export function VerifyEmailBanner() {
  const auth = useAuth()
  const [open, setOpen] = useState(false)

  if (!auth.user || auth.user.emailVerified) return null

  return (
    <div role="alert" className="border-b border-glow-600/30 bg-glow-600/10">
      <div className="mx-auto max-w-6xl px-4 py-2 text-sm text-glow-200">
        <div className="flex flex-wrap items-center gap-3">
          <span className="min-w-[14rem] flex-1">
            Verify your email
            {auth.user.email ? ` (${auth.user.email})` : ''} to create glows.
          </span>
          {!open && (
            <Button variant="secondary" onClick={() => setOpen(true)}>
              Enter code
            </Button>
          )}
        </div>
        {open && (
          <div className="mt-3 max-w-md">
            <VerifyCodeForm autoSend onVerified={() => setOpen(false)} />
          </div>
        )}
      </div>
    </div>
  )
}
